import React, { lazy, Suspense, useEffect, useReducer, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
// import { findDOMNode } from 'react-dom';
import TableBookingMobile from 'components/TableBookingMobile';
import classNames from 'classnames';
import { toggleMobileCart } from 'containers/Home/actions';
import { setState } from 'containers/Home/actions';

import { selectStoreConfig } from '../../containers/Layout/selectors';
import About from '../About/index.js';
import {
  getCurrentShift,
  getRestauranTimeArrays,
} from '../../helpers/getTimeSlots';

const LoyaltyMobile = lazy(() => import('../LoyaltyMobile/index'));
const OpenHours = lazy(() => import('../OpenHours/index.js'));

export default function Header({
  showHalfItem,
  // spMenuCategories,
  halfItem,
  // slideIndex,
  navigation,
  signOut,
  currentOrder,
  goHome,
  addReservationhandler,
  history,
  hOrder,
  // about,
  closeAbout,
  // review,
  closeReview,
  // closeReservation,
  reservation,
  closeLoyalty,
  loyalty,
  recordPhoneClickHandler,
  // updateCurrentUser,
  updateOrderStage,
  // openDelivery,
}) {
  const [state, setLocalState] = useReducer((s, a) => ({ ...s, ...a }), {
    isTableBookingOn: false,
    showReservation: false,
    useCustomTableBooking: false,
    customBookingURL: '',
    orderCount: 0,
    width: 1025,
  });
  const {
    categories,
    menuItems,
    pathwayToOffers,
    // allSpecials,
    orderSetup,
    currentUser,
    userDetails,
    openHours,
    ui: { slideIndex },
    specialFilter: {
      isSpecialFilterApplied,
      spMenuCategories,
      // spSubModifiers,
      // spMenuItems,
      // spMenuSizes,
    },
  } = useSelector((state) => state.homeReducer);
  const { allShifts, closeDates } = useSelector((state) => state.orderReducer);
  const { reviewStats, reviewStatsByRating, offers } = useSelector(
    (state) => state.layoutReducer
  );
  const storeConfig = useSelector(selectStoreConfig);
  const dispatch = useDispatch();
  const navRef = useRef(null);

  useEffect(() => {
    // document.addEventListener('click', handleOutSideClickLogin, true);
    document.addEventListener('click', handleOutSideClickReview, true);
    window.addEventListener('resize', handleWindowSizeChange, true);
    document.addEventListener('click', handleOutSideClickReservation, true);
    setLocalState({ width: window.innerWidth });

    return () => {
      // document.removeEventListener('click', handleOutSideClickLogin, true);
      document.removeEventListener('click', handleOutSideClickReview, true);
      window.removeEventListener('resize', handleWindowSizeChange, true);
      document.removeEventListener(
        'click',
        handleOutSideClickReservation,
        false
      );
    };
  }, []);

  useEffect(() => {
    if (currentOrder?.menuItems) {
      let orderCount = 0;
      currentOrder.menuItems.forEach((item) => {
        item.selectedSizes.forEach((m) => {
          orderCount = orderCount + m.quantity;
        });
      });
      setLocalState({ orderCount });
    }
  }, [currentOrder?.menuItems]);

  useEffect(() => {
    if (allShifts) {
      let obj = getCurrentShift(
        storeConfig,
        allShifts,
        closeDates ? closeDates : []
      );
      let restaurantTimes = getRestauranTimeArrays(
        storeConfig,
        allShifts,
        closeDates ? closeDates : []
      );
      setLocalState({
        currentShift: obj,
        currentLatestShift: allShifts,
        restaurantTimes,
      });
    }
  }, [allShifts, storeConfig, closeDates]);

  useEffect(() => {
    if (orderSetup) {
      setLocalState({
        isDeliveryOn: orderSetup.isDeliveryOn,
        isTableBookingOn: orderSetup.isTableBookingOn,
        useCustomTableBooking: orderSetup.useCustomTableBooking
          ? orderSetup.useCustomTableBooking
          : false,
        customBookingURL: orderSetup.customBookingURL
          ? orderSetup.customBookingURL
          : '',
      });
    }
  }, [orderSetup]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [slideIndex]);


  const handleWindowSizeChange = () =>
    setLocalState({ width: window.innerWidth });

  const handleOutSideClickReview = (e) => {
    // console.log(window.refs)
    // const reviewNode = findDOMNode(this.refs.reviewPop);
    // if (reviewNode && reviewNode.classList.contains('true')) {
    //   if (!reviewNode || !reviewNode.contains(e.target)) {
    //     closeReview(true);
    //   }
    // }
  };

  const handleOutSideClickReservation = (e) => {
    // const reservationNode = findDOMNode(this.refs.reservationPop);
    // if (reservationNode && reservationNode.classList.contains('active')) {
    //   if (!reservationNode || !reservationNode.contains(e.target)) {
    //     setLocalState({ showReservation: false });
    //   }
    // }
  };

  const closeReservation = () => {
    setLocalState({ showReservation: false });
  };

  const openIt = () => dispatch(setState({ openHours: true }));

  const closeIt = () => dispatch(setState({ openHours: false }));

  let bubbleClass = classNames('bubble white visible-xs visible-sm', {
    'only-about': !state.isTableBookingOn && !offers?.length,
    'table-booking':
      state.isTableBookingOn === true && offers && offers.length === 0,
    loyalty: !state.isTableBookingOn && offers && offers.length > 0,
    'table-booking-and-loyalty':
      state.isTableBookingOn === true && offers && offers.length > 0,
  });

  let loyaltyList = classNames({
    'loyalty-list':
      state.isTableBookingOn === true && offers && offers.length > 0,
  });

  return (
    <Suspense fallback={<div />}>
      <nav
        style={
          isSpecialFilterApplied
            ? {
                paddingBottom: 30,
                maxHeight: 120,
                overflow: 'hidden',
              }
            : {}
        }
        ref={navRef}
        className={
          currentOrder && currentOrder.stage >= 3
            ? 'navbar topnav navbar-fixed-top bgwhite compact'
            : 'navbar topnav navbar-fixed-top bgwhite'
        }
      >
        <div className='container-fluid topnav'>
          <div className='navbar-header'>
            {isSpecialFilterApplied || showHalfItem ? (
              <div
                style={{
                  padding: '0px 30px',
                  display: 'flex',
                  justifyContent: 'center',
                  flexFlow: 'row',
                }}
              >
                <span
                  className='stickyTitle'
                  style={{
                    fontSize: '2.5em',
                    marginBottom: 0,
                    textAlign: 'center',
                  }}
                >
                  Select{' '}
                  {spMenuCategories
                    .filter((f) => f.isActive)
                    .map((f) => f.name)
                    .join(' or ')}
                </span>
              </div>
            ) : (
              <div className='logoWrap' onClick={() => goHome()}>
                <img src={storeConfig.logo} alt='logo' className='logo' />
              </div>
            )}
          </div>
          {currentOrder &&
            currentOrder.stage === 5 &&
            (currentOrder.orderStatus === '4' ||
              currentOrder.orderStatus === '11' ||
              currentOrder.orderStatus === '1') && (
              <div
                className={
                  window.innerWidth > 992 &&
                  !(
                    window.navigator.userAgent.match(/iPad/i) &&
                    window.innerHeight > 1250
                  )
                    ? 'Home comGo'
                    : 'thickcon-Left-Chevron comGo'
                }
                onClick={() => goHome()}
              >
                {window.innerWidth > 992 &&
                !(
                  window.navigator.userAgent.match(/iPad/i) &&
                  window.innerHeight > 1250
                )
                  ? 'Place another Order'
                  : ''}
              </div>
            )}
          {(isSpecialFilterApplied || showHalfItem) && (
            <div
              className='backToOrder thickcon-Left-Chevron visible-xs visible-sm'
              onClick={() => hOrder(true)}
            />
          )}
          <div
            className='collapse navbar-collapse'
            id='bs-example-navbar-collapse-1'
          >
            <div style={{ display: `flex`, justifyContent: `flex-end` }}>
              {currentOrder &&
                currentOrder.stage < 3 &&
                state.isTableBookingOn && (
                  <button
                    className='header-link'
                    onClick={() => {
                      if (
                        state.useCustomTableBooking === true &&
                        state.customBookingURL !== ''
                      ) {
                        window.open(state.customBookingURL, '_blank');
                      } else {
                        dispatch(setState({ bookingOpen: true }));
                      }
                    }}
                  >
                    Booking
                  </button>
                )}
              {currentOrder && currentOrder.stage < 3 && (
                <button
                  className='header-link'
                  onClick={() => dispatch(setState({ aboutOpen: true }))}
                >
                  About
                </button>
              )}
              {currentOrder &&
                currentOrder.stage < 3 &&
                offers &&
                offers.length > 0 && (
                  <button
                    className='header-link'
                    onClick={() => dispatch(setState({ loyaltyOpen: true }))}
                  >
                    Loyalty
                  </button>
                )}
              {currentUser &&
                currentUser.phoneNumber &&
                userDetails &&
                userDetails.firstName && (
                  <button className='header-link'>
                    Welcome, {userDetails.firstName}
                  </button>
                )}
              {currentUser &&
                currentUser.phoneNumber &&
                userDetails &&
                userDetails.firstName &&
                currentOrder &&
                currentOrder.stage < 3 && (
                  <button className='header-link' onClick={signOut}>
                    Logout
                  </button>
                )}
            </div>
          </div>
          <div
            className='tabsSlider--menuContainer'
            id='tabs-menu-root'
            style={{
              opacity: isSpecialFilterApplied || showHalfItem ? 0 : 1,
            }}
          />

          {state.width <= 1024 ? (
            <React.Fragment>
              {state.orderCount > 0 &&
              currentOrder &&
              currentOrder.stage < 3 ? (
                (isSpecialFilterApplied === false ||
                  !showHalfItem === false) && (
                  <div className='visible-xs bubble visible-sm'>
                    <span
                      className='orderBubble'
                      onClick={() => dispatch(toggleMobileCart())}
                    >
                      ORDER
                      <i
                        style={{
                          backgroundColor:
                            storeConfig.storeColorCode || '#e25f28',
                        }}
                      >
                        {state.orderCount}
                      </i>
                    </span>
                  </div>
                )
              ) : currentOrder &&
                currentOrder.stage < 3 &&
                (isSpecialFilterApplied === false || !showHalfItem === false) &&
                categories &&
                orderSetup &&
                reviewStats &&
                menuItems ? (
                <div className={bubbleClass}>
                  <ul>
                    <li onClick={() => dispatch(setState({ aboutOpen: true }))}>
                      About
                      <i className='icon-Store2' />
                    </li>
                    {offers && offers.length > 0 && (
                      <li
                        onClick={() =>
                          dispatch(setState({ loyaltyOpen: true }))
                        }
                      >
                        Loyalty
                        <i className='icon-Cash' />
                      </li>
                    )}
                    {state.isTableBookingOn && (
                      <li
                        onClick={() => {
                          if (
                            state.useCustomTableBooking === true &&
                            state.customBookingURL !== ''
                          ) {
                            window.open(state.customBookingURL, '_blank');
                          } else {
                            dispatch(setState({ bookingOpen: true }));
                          }
                        }}
                        className={loyaltyList}
                      >
                        Booking
                        <i className='icon-Calendar-Time' />
                      </li>
                    )}
                  </ul>
                </div>
              ) : (
                ''
              )}
            </React.Fragment>
          ) : null}
        </div>
      </nav>

      {(window.innerWidth < 992 ||
        (window.navigator.userAgent.match(/iPad/i) &&
          window.innerHeight > 1250)) &&
        storeConfig && (
          <About
            history={history}
            // store={store}
            closeAbout={closeAbout}
            reviewStats={reviewStats}
            reviewStatsByRating={reviewStatsByRating}
            currentShift={state.currentShift}
            recordPhoneClickHandler={recordPhoneClickHandler}
            openIt={openIt}
            isDeliveryOn={state.isDeliveryOn}
            currentUser={currentUser}
            userDetails={userDetails}
            signOut={signOut}
          />
        )}

      {(window.innerWidth < 992 ||
        (window.navigator.userAgent.match(/iPad/i) &&
          window.innerHeight > 1250)) && (
        <TableBookingMobile
          reservation={reservation}
          history={history}
          closeReservation={closeReservation}
          addReservationhandler={addReservationhandler}
          restaurantTimes={state.restaurantTimes}
          closeDates={closeDates}
          currentUser={currentUser}
          userDetails={userDetails}
          updateOrderStage={updateOrderStage}
          storeConfig={storeConfig}
          orderSetup={orderSetup}
        />
      )}

      {(window.innerWidth < 992 ||
        (window.navigator.userAgent.match(/iPad/i) &&
          window.innerHeight > 1250)) && (
        <LoyaltyMobile
          history={history}
          loyalty={loyalty}
          closeLoyalty={closeLoyalty}
          currentUser={currentUser}
          userDetails={userDetails}
          updateOrderStage={updateOrderStage}
          offers={offers}
          pathwayToOffers={pathwayToOffers}
          storeConfig={storeConfig}
        />
      )}

      {(window.innerWidth < 992 ||
        (window.navigator.userAgent.match(/iPad/i) &&
          window.innerHeight > 1250)) && (
        <OpenHours
          openHours={openHours}
          closeIt={closeIt}
          allShifts={allShifts}
          storeConfig={storeConfig}
        />
      )}
    </Suspense>
  );
}

Header.propTypes = {
  categories: PropTypes.any,
  currentUser: PropTypes.any,
  signOut: PropTypes.any,
  currentOrder: PropTypes.any,
  goHome: PropTypes.any,
  addReservationhandler: PropTypes.any,
  reservation: PropTypes.any,
  userDetails: PropTypes.any,
  reviewStats: PropTypes.any,
  reviewStatsByRating: PropTypes.any,
  allShifts: PropTypes.any,
  isSpecialFilterApplied: PropTypes.any,
  history: PropTypes.any,
  rightSideViewVisibilityIndex: PropTypes.any,
  recordPhoneClickHandler: PropTypes.any,
};
